import React, { FC } from 'react';

import { useCheckHeader } from 'Src/feature/check/useCheckHeader';
import { useDayPart } from 'Src/feature/dayPart/useDayPart';
import { useDayPartSchedule } from 'Src/feature/dayPartSchedule/useDayPartSchedule';
import { useEmployee } from 'Src/feature/employee/useEmployee';
import { useFloorPlan } from 'Src/feature/floor-plan/useFloorPlan';
import { useMenu } from 'Src/feature/menu/useMenu';
import { useModifierCommand } from 'Src/feature/modifier-command/useModifierCommand';
import { usePrinter } from 'Src/feature/printer/usePrinter';
import { useRevenueCenters } from 'Src/feature/revenue-center/useRevenueCenter';
import { useVoidReason } from 'Src/feature/void-reason/useVoidReason';

/**
 * Data priming component for 'POS'
 *  - TODO: confirm and document Application browser refresh logic
 *    - when will the browser be refresh
 *    - if browser refresh is limited, initial data load will be handled via react-query
 */
const BootDataPrimerTerminal: FC = () => {
  // initial data load(s)
  useFloorPlan.query.getAll();
  useFloorPlan.query.getAllTables();
  useDayPart.query.getAll();
  useDayPartSchedule.query.getAll();
  useCheckHeader.query.getAll();
  useMenu.query.getModifiers();
  useVoidReason.query.getAll();
  useModifierCommand.query.getAll();
  usePrinter.query.getAll();
  useRevenueCenters.query.getAll();
  useEmployee.query.getAll();
  return null;
};

export { BootDataPrimerTerminal };
